import { computed } from 'vue';

export function useBuyboxView() {
	const isBuyboxViewExpActive = computed(() => true);

	return {
		isBuyboxViewExpActive,
	};
}
